import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Box, Button, Grid, Typography } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import {
  AccountCircle,
  ImportContactsOutlined,
  Inventory,
  Sailing,
} from "@mui/icons-material";
import Divider from "@mui/material/Divider";
import { Panel } from "@poseidon/ui/components/Panel";
import NestedField from "./NestedField";
import React from "react";
import { useNavigate } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import EditApplicationFormWrapper from "./EditApplicationFormWrapper";
import { useDealers } from "../../../Dealers/hooks/useDealers";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useApplicationContext } from "./ApplicationContext";
import Chip from "@mui/material/Chip";
import { Field } from "formik";
import { Checkbox } from "formik-mui";
import FormControlLabel from "@mui/material/FormControlLabel";

const optionLabel = (option) =>
  option.companyName + (option.isVerified ? "" : " (Unverified)");
const optionSelected = (item, current) => {
  return item.id === current.id;
};
const optionEqualToValue = (option, value) => {
  return option.companyName === value.companyName;
};
export function ApplicationDealerVesselPanel() {
  const navigate = useNavigate();
  const application = useApplicationContext();

  const { dealers, loading, error } = useDealers(true, application.id);
  const { setError } = useErrorMessage();
  if (error) {
    setError(error);
  }

  if (loading) {
    return <LinearProgress />;
  }
  const initialValues = {
    ...(application.dealer ? { dealer: application.dealer } : {}),
    ...(application.vessel
      ? {
          vessel: application.vessel,
        }
      : {}),
    chartering: !!application.chartering,
    travelOverseas: !!application.travelOverseas,
  };
  return (
    <EditApplicationFormWrapper
      initialValues={initialValues}
      application={application}
    >
      {({ disabled, errors, touched, values, dirty, isSubmitting }) => {
        const renderDealerPreview = (field) => {
          if (!field) {
            return (
              <Box sx={{ mb: 2 }}>
                <Chip color="default" label="No dealer selected" />
              </Box>
            );
          }
          return (
            <List>
              <ListItem disablePadding key="dealerView1">
                <ListItemButton
                  onClick={() => navigate(`/dealers/${values.dealer.id}`)}
                >
                  <ListItemText
                    primary={field.companyName}
                    secondary={
                      <Typography variant="subtitle" color="textSecondary">
                        Edit Dealer
                      </Typography>
                    }
                  />
                  <ListItemIcon>
                    <ImportContactsOutlined />
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
              <Divider />
              <ListItem key="dealerView2">
                <ListItemIcon>
                  <AccountCircle />
                </ListItemIcon>
                <ListItemText
                  primary={field.contactName}
                  secondary={field.contactEmail}
                />
              </ListItem>
            </List>
          );
        };
        const renderBoatPreview = (boat) => (
          <List>
            <ListItem disablePadding key="vesselView1">
              <ListItemButton
                onClick={() =>
                  navigate(`/applications/${application.id}/boats/${boat.id}`)
                }
              >
                <ListItemText
                  primary={boat.model}
                  secondary={
                    <Typography variant="subtitle" color="textSecondary">
                      Edit Vessel
                    </Typography>
                  }
                />
                <ListItemIcon>
                  <Sailing />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <Divider />
            <ListItem key="vesselView2">
              <ListItemIcon>
                <Inventory />
              </ListItemIcon>
              <ListItemText primary={boat.make} secondary={boat.type} />
            </ListItem>
          </List>
        );
        return (
          <Panel
            expandable
            title="Dealer & Vessel"
            anchorName="dealer-vessel"
            actions={
              <Button
                size="small"
                type="submit"
                disabled={!dirty || isSubmitting}
              >
                Save
              </Button>
            }
          >
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12} sm={6}>
                <NestedField
                  field={values.dealer}
                  renderPreview={renderDealerPreview}
                  options={dealers}
                  disabled={disabled}
                  error={!!(errors.dealer && touched.dealer)}
                  getOptionLabel={optionLabel}
                  getOptionSelected={optionSelected}
                  isOptionEqualToValue={optionEqualToValue}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                {values.vessel && (
                  <NestedField
                    field={values.vessel}
                    renderPreview={renderBoatPreview}
                    disabled={disabled}
                    error={!!(errors.vessel && touched.vessel)}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Field
                      component={Checkbox}
                      type="checkbox"
                      name="chartering"
                    />
                  }
                  label="Is Chartered"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Field
                      component={Checkbox}
                      type="checkbox"
                      name="travelOverseas"
                    />
                  }
                  label="Boat will leave UK waters"
                />
              </Grid>
            </Grid>
          </Panel>
        );
      }}
    </EditApplicationFormWrapper>
  );
}
